<!-- DO NOT PIPE CONTENT TO XSI18N -->
<div
  #containerWrapper
  *ngIf="tooltipVisible && !tooltipDisabled; else noTooltip"
  class="container-wrapper"
  [soti-tooltip]="content"
  placement="{{ position }}"
  delay="500"
>
  <div #textWrapper class="text-wrapper">{{ content }}</div>
</div>

<ng-template #noTooltip>
  <div #containerWrapper class="container-wrapper">
    <div #textWrapper class="text-wrapper">{{ content }}</div>
  </div>
</ng-template>
